import { render, staticRenderFns } from "./external-activators.vue?vue&type=template&id=1c2dfc84&scoped=true"
import script from "./external-activators.vue?vue&type=script&lang=js"
export * from "./external-activators.vue?vue&type=script&lang=js"
import style0 from "./external-activators.vue?vue&type=style&index=0&id=1c2dfc84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2dfc84",
  null
  
)

export default component.exports